<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form autocomplete="off" [formGroup]="formHeader">
    <div class="card-body justify-content-between">

      <div class="filtros-body">
        <div class="row">
          <!-- Datos del cliente -->
          <div class="col">



            <div [ngClass]="{'row': true, disabledContent: !enableClient}">
              <ng-container *ngIf="permiteUnidadNegocio">
                <div [ngClass]="{disabledContent: !enableClient}">
                  <div class="col">
                    <div class="md-form">
                      <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                        placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                      </mdb-select>
                      <div *ngIf="
                                              formHeader.get('unidad_negocio_codigo').invalid &&
                                              (formHeader.get('unidad_negocio_codigo').dirty ||
                                              formHeader.get('unidad_negocio_codigo').touched)
                                            ">
                        <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">Ingrese unidad
                          de negocio
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="col" style="max-width: 170px;">
                <!-- <Strong class="title">RUT Cliente</Strong>
                <span class="value" *ngIf="headerData?.clienteSeleccionado">
                  {{ headerData?.clienteSeleccionado.rutFormato | rut }}
                </span> -->
                <div class="md-form">
                  <input value="" type="text" id="rutproveedor" class="form-control" placeholder="" required #rutcliente
                    formControlName="rut" formatRut />
                  <label for="rutcliente">RUT</label>
                  <div *ngIf="
                            formHeader.get('rut').invalid &&
                            (formHeader.get('rut').dirty ||
                            formHeader.get('rut').touched)
                        ">
                    <mdb-error *ngIf="formHeader.get('rut').hasError('required')">
                      Ingrese rut cliente
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccionarProveedor()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" *ngIf="proveedorSeleccionado; else mjsConsultaRut" style="display: contents;">
                  {{ proveedorSeleccionado.nombre }}
                </h6>
                <ng-template #mjsConsultaRut>
                  <h6 class="text-info" style="display: contents;">Ingrese el RUT del Proveedor</h6>
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form" style="max-width: 200px;">
                  <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar sucursal"
                    [filterEnabled]="true" formControlName="sucursal"></mdb-select>
                  <div *ngIf="
                                                                          formHeader.get('sucursal').invalid &&
                                                                          (formHeader.get('sucursal').dirty ||
                                                                          formHeader.get('sucursal').touched)
                                                                        ">
                    <mdb-error *ngIf="formHeader.get('sucursal').hasError('required')">Ingrese sucursal
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col dato">
                <Strong class="title">Comuna</Strong>
                <span class="value" *ngIf="headerData?.direccion; else dummyTxt">{{ headerData.direccion.nombreComuna
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato">
                <Strong class="title">Región</Strong>
                <span class="value" *ngIf="headerData?.direccion; else dummyTxt">{{ headerData.direccion.nombreRegion
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato">
                <Strong class="title">Dirección</Strong>
                <span class="value" *ngIf="headerData?.direccion; else dummyTxt">{{
                  headerData.direccion.direccion_completa }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <mdb-select label="Condición de pago" [options]="optionsCondicionPago"
                    placeholder="Seleccionar condición de pago" [filterEnabled]="true" formControlName="condicionPago">
                  </mdb-select>
                  <div *ngIf="
                    formHeader.get('condicionPago').invalid &&
                    (formHeader.get('condicionPago').dirty ||
                    formHeader.get('condicionPago').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('condicionPago').hasError('required')">Ingrese condición de pago
                    </mdb-error>
                  </div>
                </div>
              </div>

            </div>


          </div>

          <!-- Datos de factura -->
          <div class="col">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <mdb-date-picker #datePicker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Desde'" required
                    formControlName="fechaDesde">
                  </mdb-date-picker>
                  <label for="fechaInicio">Fecha Doc.</label>
                  <div *ngIf="
                    formHeader.get('fechaDesde').invalid &&
                    (formHeader.get('fechaDesde').dirty ||
                    formHeader.get('fechaDesde').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <mdb-date-picker #datePicker [inline]="true" name="fechaHasta" [placeholder]="'Fecha Hasta.'" required
                    formControlName="fechaHasta">
                  </mdb-date-picker>
                  <label for="fechaHasta">Fecha Venc.</label>
                  <div *ngIf="
                    formHeader.get('fechaHasta').invalid &&
                    (formHeader.get('fechaHasta').dirty ||
                    formHeader.get('fechaHasta').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FIN/ FILA #2 -->


  </form>
</div>


<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>